import { Bell, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { NotificationItem } from "./NotificationItem";
import { useNotifications } from "../hooks/useNotifications";
import { cn } from "@/lib/cn";

export function NotificationBell({ className, ...props }: { className?: string; "aria-label"?: string }) {
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const recent = notifications.slice(0, 8);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button aria-label={props["aria-label"] ?? "Open notifications"} className={cn("relative rounded-[var(--radius-lg)] p-2 text-[var(--muted-foreground)] hover:bg-[var(--muted)] hover:text-[var(--foreground)] transition-colors", className)}>
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--color-error)] px-1 text-[10px] font-bold text-white">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[360px] p-0">
        <div className="flex items-center justify-between border-b border-[var(--border)] px-4 py-3">
          <h3 className="text-sm font-semibold text-[var(--foreground)]">Notifications</h3>
          {unreadCount > 0 && (
            <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={markAllAsRead}>
              <Check className="mr-1 h-3 w-3" />
              Mark all read
            </Button>
          )}
        </div>
        <div className="max-h-[400px] overflow-y-auto">
          {recent.length === 0 ? (
            <div className="py-8 text-center text-sm text-[var(--color-mute)]">No notifications yet</div>
          ) : (
            <div className="divide-y divide-[var(--border)] p-1">
              {recent.map((n) => (
                <NotificationItem key={n.id} notification={n} onRead={markAsRead} onDelete={() => {}} />
              ))}
            </div>
          )}
        </div>
        <div className="border-t border-[var(--border)] p-2">
          <Link
            to="/notifications"
            className="block w-full rounded-[var(--radius-md)] py-2 text-center text-xs font-medium text-[var(--color-primary)] hover:bg-[var(--muted)]"
          >
            View all notifications
          </Link>
        </div>
      </PopoverContent>
    </Popover>
  );
}
